import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { cloneDeep, set, entries, isEmpty } from 'lodash'

import InputTextField from '../fields/inputtextfield/InputTextField'
import InputDateField from '../fields/inputdatefield/InputDateField'
import InputNumberField from '../fields/inputnumberfield/InputNumberField'
import ErrorMessage from '../errormessage/ErrorMessage'
import { validateTerminalMaintenance, getErrorForFormField } from '../../utils/formUtils'
import Modal from '../app/customModal/Modal'
import { confirmDeletePopup } from '../popup/confirmDeletePopup'

export default class TerminalMaintenanceEdit extends PureComponent {
  static propTypes = {
    terminalId: PropTypes.string.isRequired,
    quay: PropTypes.string.isRequired,
    selectedMaintenance: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    onInsertTerminalMaintenance: PropTypes.func.isRequired,
    onUpdateTerminalMaintenance: PropTypes.func.isRequired,
    onCancelTerminalMaintenance: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      formFields: props.selectedMaintenance._id
        ? { ...props.selectedMaintenance }
        : {
            terminalId: props.terminalId,
            quayId: props.quay,
            ...props.selectedMaintenance
          },
      formErrors: {}
    }
  }

  componentDidMount() {
    // Check if it's a existing maintenance with errors
    if (entries(this.props.selectedMaintenance).length) {
      const formErrors = validateTerminalMaintenance(this.props.selectedMaintenance, this.props.config)

      // if there are form errors, set them in state
      if (!isEmpty(formErrors)) {
        this.setState({ formErrors })
      }
    }
  }

  render() {
    const { startTime, endTime, bollardStart, bollardEnd } = this.state.formFields
    // If there is no maintenance id -> we are creating a new maintenance
    const creatingNewMaintenance = !this.state.formFields._id

    return (
      <div>
        <div className="content-wrapper">
          <div className="content terminalmaintenance">
            <div className="detail-view-section">
              <h1>Information</h1>
              <div className="single-view">
                <InputTextField
                  name={'Message'}
                  fieldName={'message'}
                  fieldValue={this.state.formFields.message}
                  required={true}
                  error={getErrorForFormField(this.state.formErrors, 'message')}
                  onChange={this.onFormInputChange}
                />
              </div>
            </div>

            <div className="detail-view-section">
              <h1>Timeframe</h1>
              <div className="double-view">
                <InputDateField
                  name={'Start time'}
                  fieldName={'startTime'}
                  fieldValue={startTime}
                  required={true}
                  error={getErrorForFormField(this.state.formErrors, 'startTime')}
                  onChange={this.onFormInputChange}
                />
                <InputDateField
                  name={'End time'}
                  fieldName={'endTime'}
                  fieldValue={endTime}
                  required={true}
                  error={getErrorForFormField(this.state.formErrors, 'endTime')}
                  onChange={this.onFormInputChange}
                />
              </div>
            </div>

            <div className="detail-view-section">
              <h1>Bollards</h1>
              <div className="double-view">
                <InputNumberField
                  name={'Start bollard'}
                  fieldName={'bollardStart'}
                  fieldValue={bollardStart}
                  required={true}
                  error={getErrorForFormField(this.state.formErrors, 'bollardStart')}
                  onChange={this.onFormInputChange}
                />

                <InputNumberField
                  name={'End bollard'}
                  fieldName={'bollardEnd'}
                  fieldValue={bollardEnd}
                  required={true}
                  error={getErrorForFormField(this.state.formErrors, 'bollardEnd')}
                  onChange={this.onFormInputChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          {!isEmpty(this.state.formErrors) ? (
            <ErrorMessage message={'Please make sure that you filled in all fields correctly'} />
          ) : null}

          <Modal.Buttons>
            {!creatingNewMaintenance ? (
              <div className="no-btn btn" onClick={this.confirmDeleteTerminalMaintenance}>
                <span>Delete maintenance</span>
              </div>
            ) : null}

            <div
              className={`save-btn btn ${isEmpty(this.state.formErrors) ? 'valid' : ''}`}
              onClick={this.checkAndSubmitForm}
            >
              <span>Save</span>
            </div>
          </Modal.Buttons>
        </div>
      </div>
    )
  }

  /**
   * When the value of a form input field changes
   */
  onFormInputChange = (value, field) => {
    const formFields = cloneDeep(this.state.formFields)
    set(formFields, field, value)
    this.setState({ formFields })
  }

  /**
   * Check if form fields are correct before updating maintenance in backend
   */
  checkAndSubmitForm = () => {
    const maintenanceFormErrors = validateTerminalMaintenance(this.state.formFields, this.props.config)

    // if there are form errors, set them in state and don't continue
    if (!isEmpty(maintenanceFormErrors)) {
      this.setState({ formErrors: maintenanceFormErrors })
      return
    }

    if (this.state.formFields._id) {
      // Update the terminalmaintenance (locally && in backend)
      this.props.onUpdateTerminalMaintenance(this.state.formFields)
    } else {
      // there is no _id field -> we are creating a new maintenance
      this.props.onInsertTerminalMaintenance(this.state.formFields)
    }
  }

  /**
   * When user cancels a terminal maintenance
   */
  confirmDeleteTerminalMaintenance = () => {
    confirmDeletePopup({
      itemName: 'this terminal maintenance',
      onConfirm: this.deleteTerminalMaintenance,
      alert: true
    })
  }

  /**
   * When user deletes a terminal maintenance, pressing the yes button
   */
  deleteTerminalMaintenance = () => {
    this.props.onCancelTerminalMaintenance(this.state.formFields._id)
  }
}
